import React from 'react';
import { Link } from 'react-router'

let logoSrc = require('../../../img/wl-logo.png');

const Footer = () =>
(
    <footer className="section section-primary footer-container">
        <div className="container-fluid">
            <div className="row">

                {/*
                <div className="col-lg-7 col-md-12 col-xs-12">
                    <div className="row">
                      <div className="col-md-4 col-xs-12 vert-align">
                          <img src={logoSrc} className="center-block img-responsive" />
                      </div>
                      <div className="col-md-4 col-xs-12 vert-align">
                          <i className="material-icons">email</i> <a href="#">support@freshbytes.io</a>
                      </div>
                      <div className="col-md-4 col-xs-12 vert-align">
                          <i className="material-icons">location_on</i><p>29007 Sterling Ln Valencia CA 91354</p>
                      </div>
                    </div>
                </div>

                <div className="col-lg-5 col-md-12 col-xs-12">
                    <div className="row">
                      <div className="col-md-4 hidden-xs text-right">
                      </div>
                      <div className="col-md-4 col-xs-6 text-right vert-align">
                          <Link to="/terms">Terms</Link>
                      </div>
                      <div className="col-md-4 col-xs-6 text-center vert-align">
                          <Link to="/privacy">Privacy</Link>
                      </div>
                    </div>
                </div>
                */}

            </div>
    {/*
            <div className="row">
                <div className="col-md-12 text-center">
                    <ul className="list-inline">
                        <li>
                            <a href="#" className="btn-social btn-outline face"><i className="fa fa-fw fa-facebook"></i></a>
                        </li>
                        <li>
                            <a href="#" className="btn-social btn-outline goog"><i className="fa fa-fw fa-google-plus"></i></a>
                        </li>
                        <li>
                            <a href="#" className="btn-social btn-outline twitter"><i className="fa fa-fw fa-twitter"></i></a>
                        </li>
                    </ul>
                </div>
            </div>
    */}

        </div>
  </footer>
);

export default Footer;




// WEBPACK FOOTER //
// src/components/layout/footer.js